import { render } from "./Modal.vue?vue&type=template&id=66f9ab6b"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=66f9ab6b&lang=css"
script.render = render

export default script